var x = window.location.protocol
var y = ''
if (x == 'https:') {
    y = 'https://'
} else {
    y = 'http://'
}
module.exports = {
    HTTP: y,
    P: 'web_pop',
    V: '4.1.23',
    Local: '',
    Fkey: '23a888e183ef984d25ecf0d011ed4929',
    // 线上正式
    SERVER_PATH_: '101.132.99.204:8180/aidouapi',
    SERVER_PATH: 'www.withfans.com/FHADMINM', // 国内正式老接口
    SERVER_PATH_P: 'www.withfans.com/aidouapi',
    SERVER_PATHS: 'www.withfans.com/aidouapi', // 国内正式新接口
    SERVER_PATHEN: 'www.withfans.cn/FHADMINM', // 海外正式老接口
    SERVER_PATHCN: 'www.withfans.cn/aidouapi', // 海外正式新接口
    RONGYUNID: 'x4vkb1qpxf8mk', // 融云正式id
    ADMINURL: 'https://www.withfans.com/aidoumanage/loginphonemanage?usKey=', // 后台地址
    LINKURL: 'https://www.withfans.com',
    SERVER_PATH_MANAGE: 'www.withfans.com/aidoumanage',
		SERVER_PATH_SF: 'www.gostarfans.com/api',

    // 线上地址
    // SERVER_PATHS: '106.14.161.229:8580/aidouapi',//新接口测试地址
    // SERVER_PATH:'106.14.161.229:8580/FHADMINM',

    // 测试地址
  //   SERVER_PATH_: 'pay.withfans.com/FHADMINM',
  //   SERVER_PATH: 'pay.withfans.com/FHADMINM',
  //   SERVER_PATH_P: 'pay.withfans.com/aidouapi',
  //   SERVER_PATHS: 'pay.withfans.com/aidouapi',//新接口测试地址
  //   SERVER_PATHEN: 'hktest.withfans.com/FHADMINM',
  //   SERVER_PATHCN: 'hktest.withfans.com/aidouapi',
  //   RONGYUNID: 'x18ywvqfxbasc',
  //   ADMINURL: 'http://39.105.148.229:8081/aidoumanage/loginphonemanage?usKey=',
  //   LINKURL: 'http://pay.withfans.com',
  //   SERVER_PATH_MANAGE: 'pay.withfans.com/aidoumanage',
		// SERVER_PATH_SF: 'starfanstest.withfans.com/api',
		


    // SERVER_PATH_MANAGE: '192.168.132.1:8081/aidoumanage',



    // SERVER_PATHS: '192.168.0.110:8180/aidouapi',//新接口测试地址

    // SERVER_PATH: '192.168.3.2:8082/FHADMINM',
    // SERVER_PATHS: '192.168.3.2:8580/aidouapi',
    // SERVER_PATHS: '192.168.3.2:8180/aidouapi',//新接口测试地址
    // SERVER_PATHS: '192.168.3.6:8180/aidouapi',//新接口测试地址
    // SERVER_PATHS: '192.168.3.2:8180/aidouapi',

    //昊
    // SERVER_PATHS: '192.168.3.111:8180/aidouapi',//新接口测试地址
    // SERVER_PATH: '39.105.148.229:8280/FHADMINM',
    // SERVER_PATHCN: '192.168.3.20:8580/aidouapi',

    // 老大
    // SERVER_PATHS: '192.168.3.8:8580/aidouapi',//新接口测试地址
    // SERVER_PATH: '192.168.3.8:8580/FHADMINM',

    // 高
    // SERVER_PATH: '192.168.3.2:8580/FHADMINM',
    // SERVER_PATHS: '192.168.3.2:8580/aidouapi',// 高
    // SERVER_PATHS: '192.168.3.2:8580/aidouapi',//新接口地址

    // bobo
    // SERVER_PATH: '192.168.3.3:8180/FHADMINM',
    // SERVER_PATHS: '192.168.3.3:8180/aidouapi',//新接口地址
}
